function useMic({ mediaStream }) {
  const toggleMic = async isMuted => {
    if (isMuted) {
      mediaStream.unmuteAudio();
    } else {
      await mediaStream.muteAudio();
    }
  };

  return {
    toggleMic,
  };
}

export default useMic;
